export * from './text-to-canvas.directive';



// WEBPACK FOOTER //
// ./src/app/directives/text-to-canvas/index.ts